import $ from 'jquery';
import _ from 'underscore';
import {loadDelivery, loadConditions} from '../api/api';
import amountForm, {upadateDeliverySum, upadateGiftSum} from '../amount/amount';
import GiftForm from '../gift-card/gift-card';
import format from 'number-format.js';

export default class Checkout {
	constructor(options) {
		const defaults = {
			el: '.js-checkout',

			dom: {
				addressDelivery: '.js-address-type-delivery',
				addressSelf: '.js-address-type-self',
				order: '.js-order',
				info: '.js-order-info',
				deliveryContainer: '.js-delivery-container',
				deliveryField: '.js-delivery-field',
				deliveryTrigger: '.js-delivery-radio',
				deliveryRadio: 'delivery',
				conditionsContainer: '.js-conditions-container',
				content: '.js-order-content',
				conditionsFiel: '.js-conditions-field',
				paymentField: '.js-payment-field',
				selectBody: '.js-select-body',
				selectItem: '.js-select-item',
				selectText: '.js-select-text',
				paymentType: {
					cash: '.js-payment-type-cash',
					card: '.js-payment-type-card',
					cardOnline: '.js-payment-type-card-online'
				},
				input: {
					city: '.js-checkout-city'
				},
				cost: {
					overall: '.js-overall-cost',
					amount: '.js-overall-amount'
				}
			},

			consts: {
				cash: 'cash',
				card: 'card',
				cardOnline: 'cardOnline'
			},

			classes: {
				order: {
					state: {
						opened: 'order_state_opened'
					}
				},
				fieldset: {
					state: {
						hidden: 'checkout__fieldset_hidden'
					}
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.currentDelivery = 1;
	}

	getDom() {

		const mustacheStyleSyntax = {
			evaluate: /\{\{(.+?)\}\}/g,
			interpolate: /\{\{=(.+?)\}\}/g,
			escape: /\{\{-(.+?)\}\}/g
		};

		this.$deliveryTmp = _.template(_.unescape($('#deliveryTmp').html().trim()), mustacheStyleSyntax);
		this.$conditionTmp = _.template(_.unescape($('#conditionTmp').html().trim()), mustacheStyleSyntax);
		this.$conditionsContainer = this.$el.find(this.options.dom.conditionsContainer);
		this.$deliveryContainer = this.$el.find(this.options.dom.deliveryContainer);
		this.$order = this.$el.find(this.options.dom.order);
		this.$info = this.$el.find(this.options.dom.info);
		this.$content = this.$el.find(this.options.dom.content);
		this.$addressDelivery = this.$el.find(this.options.dom.addressDelivery);
		this.$addressSelf = this.$el.find(this.options.dom.addressSelf);
		this.$conditionsFiel = this.$el.find(this.options.dom.conditionsFiel);
		this.$deliveryField = this.$el.find(this.options.dom.deliveryField);
		this.$paymentField = this.$el.find(this.options.dom.paymentField);
		this.paymentType = {
			$cash: this.$el.find(this.options.dom.paymentType.cash),
			$card: this.$el.find(this.options.dom.paymentType.card),
			$cardOnline: this.$el.find(this.options.dom.paymentType.cardOnline)
		};
		this.$cityInput = this.$el.find(this.options.dom.input.city).find('input');
		this.$costOverall = this.$el.find(this.options.dom.cost.overall);
		this.$costAmount = this.$el.find(this.options.dom.cost.amount);
	}

	onClick(e) {
		const $target = $(e.target);
		const $order = $target.closest(this.$order);
		const $content = $order.find(this.options.dom.content);
		$order.toggleClass(this.options.classes.order.state.opened);
		$content.animate({
			height: 'toggle',
			opacity: 'toggle'
		}, 400);

	}

	loadDelivery(e, city) {
		loadDelivery(city).then(data => this.renderDelivery(data));
	}

	renderDelivery(data) {
		let method = '';
		this.$deliveryContainer.empty();
		data.items.forEach(item => {
			const node = $(this.$deliveryTmp({delivery: item}));

			if (item.checked === true) {
				node.find('input').attr('checked', 'checked');
				method = item.method;
				upadateDeliverySum(item.type, item.price);
				this.updateSum(item.price, false);
			}

			if ( item.method === 'self' && item.addresses.length ) {
				const $selectBody = this.$addressSelf.find(this.options.dom.selectBody);
				const $selectItem = this.$addressSelf.find(this.options.dom.selectItem).eq(0).clone();
				$selectBody.empty();
				item.addresses.forEach(address => {
					const $newNode = $selectItem.clone();
					$newNode.find(this.options.dom.selectText).text(address);
					$selectBody.append($newNode);
				});
			}

			this.$deliveryContainer.append(node);
		});
		loadConditions(this.currentDelivery).then( delivery => this.renderCondition(delivery, method));
		this.$deliveryTrigger = this.$el.find(this.options.dom.deliveryTrigger);
		this.$deliveryTrigger.on('click', e => this.loadConditions(e));
		this.$deliveryField.removeClass(this.options.classes.fieldset.state.hidden);

	}

	loadConditions(e) {
		const target = e.currentTarget;
		const parent = target.parentElement;
		const type = parent.querySelector('.checkout__delivery-type').innerHTML;
		const price = parent.querySelector('.checkout__delivery-price').innerHTML.replace(/₽/, '');
		upadateDeliverySum(type, price);
		this.updateSum(price, false);
		const id = $(target).attr('id');
		const method = $(target).attr('data-method');
		if (this.currentDelivery !== id) {
			this.currentDelivery = id;
			loadConditions(id).then(data => this.renderCondition(data, method));
		}
	}

	renderDeliveryMethod(method) {
		switch (method) {
			case 'self':
				this.$addressSelf.removeClass(this.options.classes.fieldset.state.hidden);
				this.$addressDelivery.addClass(this.options.classes.fieldset.state.hidden);
				break;
			case 'delivery':
				this.$addressSelf.addClass(this.options.classes.fieldset.state.hidden);
				this.$addressDelivery.removeClass(this.options.classes.fieldset.state.hidden);
				break;
			default:
				this.$addressSelf.addClass(this.options.classes.fieldset.state.hidden);
				this.$addressDelivery.addClass(this.options.classes.fieldset.state.hidden);
				break;
		}
	}

	renderPaymentType(types) {

		this.paymentType.$cash.hide();
		this.paymentType.$card.hide();
		this.paymentType.$cardOnline.hide();

		types.forEach(item => {
			switch (item) {
				case this.options.consts.cash:
					this.paymentType.$cash.show();
					break;
				case this.options.consts.card:
					this.paymentType.$card.show();
					break;
				case this.options.consts.cardOnline:
					this.paymentType.$cardOnline.show();
					break;
				default:

			}
		});
		this.$paymentField.removeClass(this.options.classes.fieldset.state.hidden);
	}

	renderCondition(data, method) {

		this.$conditionsContainer.empty();
		data.items.forEach(item => {
			this.$conditionsContainer.append(this.$conditionTmp({title: item}));
		});
		this.renderDeliveryMethod(method);
		this.renderPaymentType(data.paymentType);
		this.$conditionsFiel.removeClass(this.options.classes.fieldset.state.hidden);
	}

	priceToNum = str => Number(str.replace(/[^0-9]/g, ''));

	setSum = (el, sum) => {
		el.text(format( '# ##0.## ₽', sum));
	};

	updateSum = (value, isChecked) => {
		const cost = this.priceToNum(this.$costOverall.text());
		const totalCost = this.priceToNum(this.$costAmount.text());
		if (isChecked) {
			this.setSum(this.$costOverall, cost + value);
			this.setSum(this.$costAmount, totalCost + value);
		} else {
			this.setSum(this.$costOverall, cost - value);
			this.setSum(this.$costAmount, totalCost - value);
		}
	}
	render() {
		if (this.$el.length) {
			this.getDom();
			this.$info.on('click', this.onClick.bind(this));
			this.$el.on('choose', (e, city) => this.loadDelivery(e, city));
			amountForm();
			const gift = new GiftForm(upadateGiftSum);
			gift.render();
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/checkout/checkout.js
 **/